import AgoraRTC from 'agora-rtc-sdk-ng'
import EventEmitter from 'events'

export default class RTCClient {
  constructor() {
    // Options for joining a channel
    this.client = null
    this._eventBus = new EventEmitter()
    this.uid = ""

    this.localTracks = {
      videoTrack: null,
      audioTrack: null,
      screenVideoTrack: null,
      screenAudioTrack: null
    };

  }

  on(eventName, callback) {
    this._eventBus.on(eventName, callback)
  }

  clientListener() {
    const client = this.client;

    client.on("user-published", async (user, mediaType) => {
      await client.subscribe(user, mediaType);
      if(mediaType === "video") {
        this._eventBus.emit('user-published', user);
      }
    });

    client.on("user-left", async (user, reason) => {
      this._eventBus.emit('user-left', user, reason);
    });

  }

  //init client and Join a channel
  async joinChannel(option, isBroadcast) {
    const mode = isBroadcast ? "rtc" : "live";
    this.client = AgoraRTC.createClient({mode: mode, codec: "vp8"});
    this.client.setClientRole("host");

    this.clientListener();

    [ option.uid, this.localTracks.audioTrack, this.localTracks.videoTrack ] = await Promise.all([
      this.client.join(option.appid, option.channel, option.token || null, option.uid || null),
      AgoraRTC.createMicrophoneAudioTrack({
        AEC: true,
        AGC: true,
        ANS: true,
        encoderConfig: "high_quality_stereo",
      }),
      AgoraRTC.createCameraVideoTrack(),
    ]).catch(() => {
      alert("You need turn on camera and microphone in browser before connect to stream! After that please onreload page!")
    })

    this.localTracks.videoTrack.play("presenter");
    await this.localTracks.audioTrack.setEnabled(true);

    await this.client.publish([this.localTracks.videoTrack, this.localTracks.audioTrack]);
    await this._eventBus.emit('start-stream', option.uid);
  }

  async leaveChannel() {
    this.localTracks.audioTrack.close();
    this.localTracks.videoTrack.close();
    if(this.localTracks.screenVideoTrack){
      this.localTracks.screenVideoTrack.close();
    }
    if(this.localTracks.screenAudioTrack){
      this.localTracks.screenAudioTrack.close();
    }
    await this.client.unpublish();
    await this.client.leave();
  }

  async disableVideo(isDisableVideo) {
    if(isDisableVideo){
      await this.localTracks.videoTrack.setMuted(false);
    } else {
      await this.localTracks.videoTrack.setMuted(true);
    }
  }

  async disableAudio(isDisableAudio) {
    if(isDisableAudio) {
      await this.localTracks.audioTrack.setMuted(false);
    } else {
      await this.localTracks.audioTrack.setMuted(true);
    }
  }

  async shareScreen(isDisableScreen, isDisableAudio, isDisableVideo) {
    await this.client.unpublish();
    await this.localTracks.audioTrack.setMuted(false);

    if(isDisableScreen){
      this.localTracks.videoTrack.close();


      const screenTrack = await AgoraRTC.createScreenVideoTrack({
      }, "auto");

      if(screenTrack instanceof Array){
        this.localTracks.screenVideoTrack = screenTrack[0]
        this.localTracks.screenAudioTrack = screenTrack[1]
      } else {
        this.localTracks.screenVideoTrack = screenTrack
      }

      this.localTracks.screenVideoTrack.play("presenter");

      if(this.localTracks.screenAudioTrack == null) {
        await this.client.publish([
          this.localTracks.screenVideoTrack,
          this.localTracks.audioTrack
        ]);
      } else {
        await this.client.publish([
          this.localTracks.screenVideoTrack,
          this.localTracks.audioTrack,
          this.localTracks.screenAudioTrack
        ]);
      }
      if(!isDisableAudio){
        await this.localTracks.audioTrack.setMuted(true);
      }
    } else {
      this.localTracks.screenVideoTrack.close();
      this.localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack();

      if(!isDisableVideo) {
        await this.localTracks.videoTrack.setMuted(true);
      } else {
        await this.localTracks.videoTrack.setMuted(false);
      }

      if(!isDisableAudio){
        await this.localTracks.audioTrack.setMuted(true);
      } else {
        await this.localTracks.audioTrack.setMuted(false);
      }

      this.localTracks.videoTrack.play("presenter");
      await this.client.publish([
        this.localTracks.videoTrack,
        this.localTracks.audioTrack
      ]);
    }
  }
}
